
import { useLanguage } from '@/hooks/useLanguage';

interface CVEErrorStateProps {
  error: string;
}

export function CVEErrorState({ error }: CVEErrorStateProps) {
  const { t } = useLanguage();
  
  return (
    <div className="text-center py-10">
      <p className="text-destructive">{t('cve.error')}: {error}</p>
    </div>
  );
}
